import React from 'react'

import { IconProps } from '.'

const Edit: React.FC<IconProps> = ({
  size = 24,
  color = '#E55C8A',
  ...rest
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1512 4.29354C13.7553 3.68946 14.5746 3.3501 15.4289 3.3501C17.2078 3.3501 18.65 4.79223 18.65 6.5712C18.65 7.42549 18.3106 8.24479 17.7065 8.84886L16.9689 9.58651C16.9626 9.59307 16.9562 9.5995 16.9496 9.6058L13.7897 12.7657C12.0036 14.5518 9.76564 15.8189 7.31513 16.4315L6.55809 16.6208C5.84616 16.7988 5.20129 16.1539 5.37927 15.442L5.56853 14.6849C6.18116 12.2344 7.44827 9.99646 9.23437 8.21036L12.3943 5.0504C12.4006 5.04388 12.407 5.0375 12.4135 5.03127L13.1512 4.29354ZM12.2667 7.01649L10.1536 9.1296C8.53411 10.7491 7.3852 12.7783 6.82972 15.0002L6.77301 15.227L6.99983 15.1703C9.22177 14.6149 11.251 13.4659 12.8705 11.8464L14.9836 9.73334C14.3478 9.52953 13.7639 9.13743 13.3133 8.68678C12.8626 8.23613 12.4705 7.65226 12.2667 7.01649ZM16.1622 8.55469C15.5984 8.66895 14.8552 8.39025 14.2325 7.76754C13.6098 7.14483 13.3311 6.40165 13.4454 5.83784L14.0704 5.21277C14.4307 4.8525 14.9193 4.6501 15.4289 4.6501C16.4899 4.6501 17.35 5.5102 17.35 6.5712C17.35 7.08071 17.1476 7.56935 16.7873 7.92962L16.1622 8.55469Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.34998 20.0001C4.34998 19.6411 4.64099 19.3501 4.99998 19.3501H19C19.359 19.3501 19.65 19.6411 19.65 20.0001C19.65 20.3591 19.359 20.6501 19 20.6501H4.99998C4.64099 20.6501 4.34998 20.3591 4.34998 20.0001Z"
        fill={color}
      />
    </svg>
  )
}

export default Edit
